<template>
  <div id="login">
    <div class="row">
      <div class="login-layer">
        <div class="login-box">
          <div class="logo">
            <object class="img-responsive"
                    type="image/svg+xml"
                    :data="logoImage"
                    width="100%"
                    height="100%"
            >
              현재 사용 중인 브라우저는 비즈해줌 로고 이미지를 지원하지 않습니다.
            </object>
          </div>
          <form class="login-form" @submit.prevent="onSubmit">
            <div class="login-form-header">로그인</div>
            <div class="login-form-body">
              <div class="form-group margin-bottom-8">
                <input type="text"
                       ref="inputId"
                       :class="['hz-input-default', 'hz-input-lg', { 'is-invalid': isInvalid }]"
                       maxlength="20"
                       autocomplete="off"
                       data-vv-name="id"
                       data-vv-validate-on="none"
                       v-validate="{required: true}"
                       v-model="userInfo['username']"
                       placeholder="아이디"
                       :readonly="isSending"
                />
              </div>
              <div class="form-group margin-bottom-16">
                <input type="password"
                       :class="['hz-input-default', 'hz-input-lg', { 'is-invalid': isInvalid }]"
                       maxlength="40"
                       autocomplete="off"
                       data-vv-name="password"
                       data-vv-validate-on="none"
                       v-validate="{required: true}"
                       v-model="userInfo['password']"
                       placeholder="비밀번호"
                       :readonly="isSending"
                />
              </div>
              <p v-show="isInvalid" class="is-invalid-text">{{ invalidMessage }}</p>
              <div class="link-wrap margin-bottom-16">
                <p>아이디/비밀번호를 잊어버리셨나요?</p>
                <router-link to="findmyinfo">계정찾기</router-link>
              </div>
              <div class="link-wrap margin-bottom-40">
                <p>아직 비즈해줌 회원사가 아니신가요?</p>
                <router-link to="register">회원사가입</router-link>
              </div>
            </div>
            <div class="login-form-footer">
              <button type="submit" class="hz-btn-primary hz-btn-lg" :disabled="isSending">로그인</button>
            </div>
          </form>
          <router-link to="register" class="banner">
            <img src="~@/assets/img/img-login-banner.jpg" class="img-responsive" alt="비즈해줌 회원가입 혜택 배너">
          </router-link>
        </div>
        <div class="blank"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'login',
    data () {
      return {
        isSending: false,
        isInvalid: false,
        invalidMessage: '',
        logoImage: require('../assets/svg/logo/logo-biz.svg'),
        userInfo: {
          username: '',
          password: ''
        }
      }
    },
    computed: {
      ...mapGetters({
        user: 'user'
      })
    },
    watch: {
      'userInfo': {
        handler () {
          if (this.isInvalid) {
            this.isInvalid = false
          }
        },
        deep: true
      }
    },
    methods: {
      ...mapActions([
        'showToastMessage'
      ]),
      onSubmit () {
        this.$validator.validateAll().then(valid => {
          if (valid) {
            this.tryLogin()
            this.isInvalid = false
          } else {
            this.invalidMessage = '아이디와 비밀번호를 입력하세요.'
            this.isInvalid = true
          }
        })
      },
      tryLogin () {
        this.isSending = true

        // 로그인 유저 검증 및 토큰 발급
        this.$store.dispatch('getToken', this.userInfo).then(async (response) => {
          // 유저 정보 및 수익조건 불러오기
          const isHonestUser = await this.getUserInfo(response.token)

          // jango로 비정상적인 회원가입을한 유저일때 로그아웃
          if (!isHonestUser) {
            this.invalidMessage = '권한이 없는 사용자입니다.'
            this.isInvalid = true
            this.$store.commit('LOGOUT')
          }

          this.getUserCondition()

          this.isSending = false
        }).catch(() => {
          this.invalidMessage = '아이디 또는 비밀번호가 올바르지 않습니다.'
          this.isInvalid = true
          this.isSending = false
        })
      },
      async getUserInfo (token = '') {
        let isHonestUser = false

        await this.$store.dispatch('getUserInfo', token).then((response) => {
          // jango로 비정상적인 회원가입을한 유저 체크
          if (!response.result.hasOwnProperty('auth_level')) {
            return isHonestUser
          }

          // 라우터에 다음에 이동할 경로가 있을 경우에 지정된 경로로 이동, 없을 경우 인덱스 페이지로 이동
          const queryNext = this.$route.query.next
          if (queryNext) {
            return this.$router.push(queryNext)
          }

          // 비인증 사용자의 경우, 알림을 띄운다.
          if (response.result.auth_level === '0') {
            alert(response.detail)
            this.$router.push('/mypage')
          } else {
            this.$router.push('/')
          }

          isHonestUser = true
        }).catch(() => {
          this.showToastMessage('저장된 사용자정보 불러오기 실패')
        })

        return isHonestUser
      },
      getUserCondition () {
        // 로그인한 유저에 저장된 수익조건을 불러온다.
        this.$store.dispatch('getUserCondition').catch(() => {
          this.showToastMessage('저장된 수익조건 불러오기 실패')
        })
      }
    },
    created () {
      const token = localStorage.getItem('_t')

      // 토큰이 있을 경우, 토큰의 유호성을 검사한다.
      if (token) {
        this.$store.dispatch('inspectToken', token).then(() => {
          this.$router.push({name: 'index'})
        })
      }
    },
    mounted () {
      this.$refs.inputId.focus()
    }
  }
</script>

<style lang="scss" scoped>
  #login {
    width: 100%;
    height: 100%;
    background-color: $hzc-gray-01;

    .login-layer {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      padding-top: 64px;
      text-align: center;

      .blank {
        display: inline-block;
        width: 0;
        height: 100%;
        vertical-align: middle;
      }
    }

    .login-box {
      display: inline-block;
      vertical-align: middle;
      height: auto;
      width: 350px;
      margin: auto;

      @media (max-width: $screen-xs-max) {
        width: calc(100% - 32px);
      }
    }

    .login-form{
      margin: 0 0 24px;
      padding: 40px;
      background-color: $hzc-white;
      box-shadow: 0 8px 8px 0 rgba(0, 0, 0, 0.06);
      border-radius: 6px;

      @media(max-width: 767px) {
        padding: 24px;
      }

      input {
        width: 100%;
      }

      .col-xs-12 {
        padding: 0;
      }

      &-header {
        margin: 0 0 32px;
        font-size: 20px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.4;
        letter-spacing: -0.8px;
        text-align: center;
        color: $font-color;
      }

      &-body {
        .is-invalid-text {
          margin: 0 0 16px;
        }

        .link-wrap {
          display: inline-block;
          width: 100%;

          p, a {
            display: inline-block;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            float: left;
          }

          p {
            width: calc(100% - 72px);
            margin: 0;
            letter-spacing: -0.8px;
            color: $font-color;
            float: left;
          }

          a {
            display: inline-block;
            width: 72px;
            letter-spacing: -0.58px;
            text-align: right;
            color: #ff7133;
          }
        }
      }

      &-footer {
        button {
          width: 100%;
        }
      }
    }

    .logo {
      width: 205px;
      height: 27px;
      margin: 0 auto 32px;
    }

    .banner {
      display: block;
      height: 72px;
      width: 350px;
      border-radius: 4px;

      .img-responsive {
        margin: 0 auto;
      }

      @media (max-width: $screen-xs-max) {
        width: 100%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue